import { useState } from "react";
import { CountdownBar } from "@/components/CountdownBar";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { HowItWorks } from "@/components/HowItWorks";
import { DealBanner } from "@/components/DealBanner";
import { Pricing } from "@/components/Pricing";
import { Footer } from "@/components/Footer";
import { FloatingToilet } from "@/components/FloatingToilet";
import { PreOrderModal } from "@/components/PreOrderModal";

export default function Landing() {
  const [preorderOpen, setPreorderOpen] = useState(false);
  const [footChoice, setFootChoice] = useState("both");
  const openPreorder = (foot) => {
    setFootChoice(typeof foot === "string" ? foot : "both");
    setPreorderOpen(true);
  };

  return (
    <div data-testid="landing-page" className="min-h-screen bg-navy text-cream overflow-x-clip">
      <CountdownBar />
      <Nav onPreorder={openPreorder} />
      <main>
        <Hero onPreorder={openPreorder} />
        <Marquee />
        <Manifesto />
        <HowItWorks />
        <DealBanner onPreorder={openPreorder} />
        <Pricing onPreorder={openPreorder} />
      </main>
      <Footer />
      <FloatingToilet />
      <PreOrderModal open={preorderOpen} onOpenChange={setPreorderOpen} defaultFoot={footChoice} />
    </div>
  );
}
